import { Root, Trigger } from '@radix-ui/react-tooltip';

import { OmitStrict } from '../../types';

import PortalTooltipContent from './PortalTooltipContent';
import { TooltipProps } from './types';

type Props = React.PropsWithChildren<
  OmitStrict<TooltipProps, 'isClickMode' | 'isDisabled'>
>;

/**
 * Basic tooltip that is opened on hover
 */
const BasicTooltip: React.FC<Props> = ({
  children,
  content,
  asChild = true,
  defaultOpen,
  open,
  onOpenChange,
  ...contentProps
}) => (
  <Root defaultOpen={defaultOpen} open={open} onOpenChange={onOpenChange}>
    <Trigger asChild={asChild}>{children}</Trigger>
    <PortalTooltipContent content={content} {...contentProps}>
      {children}
    </PortalTooltipContent>
  </Root>
);

export default BasicTooltip;
